import {
  UPDATE_VALID_FORM_DATA,
  UPDATE_CLAIM_DATA,
  UPDATE_FROM_GETDATA,
  ADD_BENEFIT_ITEM,
  RESET_PET_LOSS,
} from "../actions"

// Develop note
// Now the initial state is left in pristine conditions and the resulting state is just a copy of the initial state. Remember two key points for avoiding mutations in Redux:
// --use concat(), slice(), or the spread operator for arrays
// --use Object.assign() or object spread of objects

const initialClaimData = {
  claimAttributeModel: {
    upStatus: "",
    contractClass: "",
    contractType: "",
    purchaseDt: "",
  },
  petClaimHeaderModel: {
    //Page 1
    //policyNumber: "M0008972", //M0008972
    //gigaCoverReferenceNumber: "HEP00001-123456-001",
    //claimantName: "AN BIN HUSIN",
    //claimantEmail: "XieBin.W@devops.etiqa.com.sg",
    //claimantMobile: "92389728",
    //claimantNricNumber: "S1223232G",
    //petDateofBirth: "22/12/2022",
    //mcEndDate: "NA",
    policyNumber: "",
    claimantName: "",
    claimantEmail: "",
    claimantMobile: "",
    claimantNricNumber: "",

    productType: "",
    sourceSystem: "",
    planPeriodFrom: "",
    planPeriodTo: "",
  },
  petClaimDetailsModel: {
    policyHolderAddress: "",
    petName: "",
    petGender: "",
    petMicrochipNumber: "",
    petDateofBirth: "",
    petTypeofBreed: "",

    haveOtherInsurer: false,
    otherInsurerName: "",
    otherInsurerPolicyNumber: "",
    claimOtherInsurer: false,

    formLocation: null,
    declaration: false,
  },
  petClaimLossDetailsModel: {
    coverageId: 0,
    claimType: "",  
    claimAmount: 0,
    claimAmountAfterDeductible: 0,
    isFollowUpClaim: false,
    diagnosis: "",  
    symptomsStartDate: "",  
    firstTreatedDate: "",  
    lastTreated: false,  
    lastFirstTreatedDate: "",  
    lastVeterinarianName: "",  
    lastVeterinarianAddress: "",
    illnessType: "Non-Surgical",  //this illness type only for UI usage
    accidentType: "",  //will pass to backend to identify STP or non-STP
    accidentTypeDescription: "", //if accident type is others, this field will capture the description for backend use
    acciedentDate: "",  
    accidentCircumstance: "",  
    natureOfInjuries: "",  
    dateOfDeath: "",
    deathCause: "",  
    euthanasiaReason: "",  
    incidentNotifiedDate: "",  
    incidentPlace: "",  
    incidentDetails: "",  
    injuredName: "",  
    injuredMobile: "",  
    injuredEmail: "",  
    injuredDetail: "",  
    damageItem: "",  
    damageMobile: "",  
    damageEmail: "",  
    damageDesc: "",
  },
  claimPayoutModel: {
    payoutType: "Direct Credit",
    bankBIC: "",
    bankName: "",
    accountNumber: "",
    accountName: "",
  },
  claimUploadListModel: null,
  folderName: null,
  sessionId: null,
  selectedBenefitsDetail: [],
}

const claimDataReducer = (state = initialClaimData, action) => {
  const newState = Object.assign({}, state)
  let targetModal = action.targetModal

  switch (action.type) {
    case UPDATE_VALID_FORM_DATA:
      return {
        ...state,
        [targetModal]: {
          ...state[targetModal],
          ...action.newData,
        },
      }

    case UPDATE_CLAIM_DATA:
      return {
        ...state,
        [targetModal]: action.newData,
    }

    case UPDATE_FROM_GETDATA:
      let claimDetailProperty = "petClaimDetailsModel"
      return {
        ...state,
        [claimDetailProperty]: {
          ...state[claimDetailProperty],
          [targetModal]: action.newData,
        },
      }

    case ADD_BENEFIT_ITEM:
      return {
        ...state,
        [targetModal]: action.newItemList,
      }

      case RESET_PET_LOSS:
        return {
          ...state,
          ["petClaimLossDetailsModel"]: initialClaimData.petClaimLossDetailsModel,
      }

    default:
      return newState
  }
}

export default claimDataReducer
